import { BookMarked, Ticket } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type AddToRequestMenuProps = {
    disabled?: boolean;
    onAddToCatalog: () => void;
    onAddOneOffBooking: () => void;
};

export function AddToRequestMenu(props: AddToRequestMenuProps) {
    const { disabled, onAddToCatalog, onAddOneOffBooking } = props;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger disabled={disabled} render={<Button type="button" />}>
                Add to request
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-72">
                <DropdownMenuItem
                    className="items-start gap-3 px-3 py-2.5"
                    onClick={onAddToCatalog}
                >
                    <BookMarked className="mt-0.5 size-4 shrink-0 text-muted-foreground" />
                    <span className="flex min-w-0 flex-col gap-0.5">
                        <span className="font-medium text-sm">Catalog item</span>
                        <span className="whitespace-normal text-muted-foreground text-xs">
                            Create a new item to catalog. Can be reused and published.
                        </span>
                    </span>
                </DropdownMenuItem>
                <DropdownMenuItem
                    className="items-start gap-3 px-3 py-2.5"
                    onClick={onAddOneOffBooking}
                >
                    <Ticket className="mt-0.5 size-4 shrink-0 text-muted-foreground" />
                    <span className="flex min-w-0 flex-col gap-0.5">
                        <span className="font-medium text-sm">One-off booking</span>
                        <span className="whitespace-normal text-muted-foreground text-xs">
                            Unique, one-time use. Will not be saved to catalog.
                        </span>
                    </span>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
